import { render, staticRenderFns } from "./BlockRadioGroup.vue?vue&type=template&id=08625e5c&scoped=true"
import script from "./BlockRadioGroup.vue?vue&type=script&lang=ts"
export * from "./BlockRadioGroup.vue?vue&type=script&lang=ts"
import style0 from "./BlockRadioGroup.vue?vue&type=style&index=0&id=08625e5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08625e5c",
  null
  
)

export default component.exports